import { BarLegendProps } from '@nivo/bar';

import { theme } from './theme-dashboard';

export const FLOW_CHART_LEGENDS: BarLegendProps[] = [
  {
    dataFrom: 'keys',
    anchor: 'top-left',
    direction: 'row',
    justify: false,
    translateY: -32,
    translateX: 0,
    itemWidth: 60,
    itemHeight: 20,
    symbolSize: 20,
    symbolShape: 'circle',
    // TODO: Use theme colors
    data: [
      {
        id: 'old',
        label: 'Old',
        color: '#04785766',
      },
      {
        id: 'recent',
        label: 'Recent',
        color: theme.tokens.emerald[700],
      },
    ],
  },
];

export const CC_CHART_LEGENDS: BarLegendProps[] = [
  {
    dataFrom: 'keys',
    anchor: 'top-left',
    direction: 'row',
    justify: false,
    translateY: -30,
    translateX: 20,
    itemWidth: 80,
    itemHeight: 20,
    symbolSize: 20,
    symbolShape: 'circle',
    // TODO: Use theme colors
    data: [
      {
        id: 'simple',
        label: 'Simple',
        color: '#04785766',
      },
      {
        id: 'complex',
        label: 'Complex',
        color: theme.tokens.emerald[700],
      },
    ],
  },
];